export default __webpack_public_path__ + "static/media/finD.3afe9ac8.svg";